import React from "react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "./ui/tooltip";

/**
 * Renders the first `limit` items as small chips, then a "+N more" badge that
 * reveals the full list inside a hover Tooltip.
 *
 * items: string[] | {label: string, key?: string}[]
 */
export default function ChipList({
  items = [],
  limit = 2,
  testId = "chip-list",
  chipClassName = "text-[10px] uppercase tracking-wider px-1.5 py-0.5 bg-[var(--brand-primary)]/8 text-[var(--brand-primary)] border border-[var(--brand-primary)]/20 rounded-sm",
  moreClassName = "text-[10px] uppercase tracking-wider px-1.5 py-0.5 bg-[#FAFAFA] text-[#525252] border border-black/10 rounded-sm hover:bg-black/5 cursor-help",
}) {
  if (!items || items.length === 0) return <span className="text-[10px] text-[#525252]">—</span>;
  const normalized = items.map((it, i) => (typeof it === "string" ? { label: it, key: `${it}-${i}` } : { label: it.label, key: it.key || `${it.label}-${i}` }));
  const visible = normalized.slice(0, limit);
  const hidden = normalized.slice(limit);
  return (
    <div className="flex flex-wrap gap-1 max-w-full" data-testid={testId}>
      {visible.map((it) => (
        <span key={it.key} className={chipClassName} title={it.label}>{it.label}</span>
      ))}
      {hidden.length > 0 && (
        <TooltipProvider>
          <Tooltip delayDuration={120}>
            <TooltipTrigger asChild>
              <button type="button" tabIndex={0} data-testid={`${testId}-more`} className={moreClassName}>
                +{hidden.length} more
              </button>
            </TooltipTrigger>
            <TooltipContent side="top" className="bg-[#0A0A0A] text-white text-xs px-2.5 py-1.5 rounded-sm max-w-xs">
              <div className="text-[10px] uppercase tracking-wider text-white/60 mb-1">All ({normalized.length})</div>
              <ul className="space-y-0.5" data-testid={`${testId}-tooltip-list`}>
                {normalized.map((it) => (
                  <li key={it.key} className="text-xs">• {it.label}</li>
                ))}
              </ul>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
